export const GET_MEDIA = 'GET_MEDIA';
export const GET_MEDIA_SUCCESS = 'GET_MEDIA_SUCCESS';
export const GET_MEDIA_FAILED = 'GET_MEDIA_FAILED';
